<template>
  <a class="grid files__file-link">
    <div class="grid__col--1 modal-file__icon-container h-center-align h-no-padding">
      <span class="glyphicon glyphicon-cloud-download queue-detail__glyph modal-file__icon modal-file__icon--blank" aria-hidden="true"></span>
    </div>
    <div class="grid__col--11 h-no-padding modal-file__text-container h-no-padding h-no-margin">
      <div class="modal-file__title modal-file__title--blank modal-file--blank"></div>
    </div>
  </a>
</template>

<script>
  export default {
    name: 'FileAttachmentSkeleton',
  };
</script>
